function parsePositiveInteger(value) {
    const number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
}

function parseSetContents(rawValue) {
    let entries;

    try {
        entries = JSON.parse(rawValue || 'null');
    } catch (error) {
        return null;
    }

    // A regular plant variant contains one plant and has no Setinhalt entries.
    if (entries === null) return 1;
    if (typeof entries === 'string') entries = [entries];
    if (!Array.isArray(entries) || entries.length === 0) return null;

    let plantCount = 0;
    for (const entry of entries) {
        if (typeof entry !== 'string') return null;

        const match = entry.match(/^\s*(\d+)\s*[x×]\s*(\S+)\s*$/i);
        const quantity = match && parsePositiveInteger(match[1]);
        if (!quantity) return null;

        plantCount += quantity;
        if (!Number.isSafeInteger(plantCount)) return null;
    }

    return plantCount || null;
}

function getVariantRequirement(element) {
    const minimum = parsePositiveInteger(element.dataset.minimum);
    const maximum = element.dataset.maximum
        ? parsePositiveInteger(element.dataset.maximum)
        : null;

    if (!minimum || (element.dataset.maximum && !maximum)) return null;
    if (maximum && maximum < minimum) return null;

    return { minimum, maximum: maximum || minimum, isRange: Boolean(maximum) };
}

function getPlantRequirement(element) {
    const variantRequirement = getVariantRequirement(element);
    const plantCount = parseSetContents(element.dataset.setContents);

    if (!variantRequirement || !plantCount) return null;

    const actualMinimum = variantRequirement.minimum * plantCount;
    const actualMaximum = variantRequirement.maximum * plantCount;
    if (!Number.isSafeInteger(actualMinimum) || !Number.isSafeInteger(actualMaximum)) return null;

    return { plantCount, actualMinimum, actualMaximum, isRange: variantRequirement.isRange };
}

function formatNumber(value) {
    return value.toLocaleString('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
}

if (!customElements.get('product-plant-coverage')) {
    customElements.define('product-plant-coverage', class extends HTMLElement {
        connectedCallback() {
            this.addEventListener('quantity:change', this._handleQuantityChange);
            this.addEventListener('change', this._handleNativeChange);
            this._update();
        }

        disconnectedCallback() {
            this.removeEventListener('quantity:change', this._handleQuantityChange);
            this.removeEventListener('change', this._handleNativeChange);
        }

        _handleQuantityChange = ({ detail }) => {
            this._update(detail.quantity);
        };

        _handleNativeChange = ({ target }) => {
            if (target.matches('select[name="quantity"]')) this._update(target.value);
        };

        _update(quantity) {
            const row = this.querySelector('[data-element="coverage-row"]');
            const value = this.querySelector('[data-element="coverage-value"]');
            const requirement = getVariantRequirement(this);
            const input = this.querySelector('input[name="quantity"], select[name="quantity"]');
            const selectedQuantity = parsePositiveInteger(quantity || input?.value);

            if (!row || !value || !requirement || !selectedQuantity) {
                if (row) row.hidden = true;
                return;
            }

            const lowerCoverage = selectedQuantity / requirement.maximum;
            const upperCoverage = selectedQuantity / requirement.minimum;

            value.textContent = requirement.isRange
                ? `${formatNumber(lowerCoverage)} - ${formatNumber(upperCoverage)} m²`
                : `${formatNumber(upperCoverage)} m²`;
            row.hidden = false;
        }
    });
}

document.querySelectorAll('[data-plant-requirement-entry]').forEach((entry) => {
    const requirement = getPlantRequirement(entry);
    if (!requirement) return;

    const value = entry.querySelector('[data-element="plant-requirement-value"]');
    if (!value) return;

    value.textContent = requirement.isRange
        ? `${requirement.actualMinimum} - ${requirement.actualMaximum} Pflanzen pro m²`
        : `${requirement.actualMinimum} Pflanzen pro m²`;
    entry.hidden = false;
});

document.querySelectorAll('#product-specs-columns .product-specs-column').forEach((column) => {
    if (!column.querySelector('.\\#product-specs-item:not([hidden])')) column.hidden = true;
});
